import React from 'react';

import { FormItemWrapper, FormItemLabel, TextareaContent } from '../FormItem.style';
import { TTextareaProps } from './Textarea.types';

// eslint-disable-next-line react/display-name
export const Textarea = React.forwardRef<HTMLTextAreaElement, TTextareaProps>(
  ({ error, onChange, placeholder, ...inputProps }, ref) => {
    return (
      <FormItemWrapper>
        <TextareaContent
          error={error}
          onChange={onChange}
          ref={ref}
          {...inputProps}
          placeholder=" "
        />
        <FormItemLabel>{placeholder}</FormItemLabel>
      </FormItemWrapper>
    );
  }
);
